import React from "react";
import styled from "styled-components";
import ImageTarget2_01 from "../../assets/images/img-target2-01.png";
import ImageTarget2_02 from "../../assets/images/img-target2-02.png";
import ImageTarget2_03 from "../../assets/images/img-target2-03.png";
import GridItem from "./Layout/GridItem";
import InnerSection from "./Layout/InnerSection";
import Section from "./Layout/Section";
import ThreeColumnGrid from "./Layout/ThreeColumnGrid";
import SubTitle from "./Text/SubTitle";
import TextBlock from "./Text/TextBlock";
function TargetContainer2({ children }) {
  return (
    <Section padding="100px 0" id="page6">
      <InnerSection>
        <SubTitle fontSize="40" data-aos="fade-up" data-aos-duration="1000">
          채용/파견 상품 런칭 기념 이벤트
        </SubTitle>
        <ColumnGrid>
          <GridItem data-aos="fade-up" data-aos-duration="1000">
            <TargetImage src={ImageTarget2_01} alt="icon" />
            <TextBlock fontSize="16" textAlign="center">
              프리미엄 생수를 차량에 비치해 탑승자에게<br />
              제공해 드립니다.<br />
              <b>※파견 상품에 한함</b>
            </TextBlock>
          </GridItem>
          <GridItem
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-delay="50"
          >
            <TargetImage src={ImageTarget2_02} alt="icon" />
            <TextBlock fontSize="16" textAlign="center">
              고용하고자 하는 드라이버를 1개월 구독 상품을 통해<br />
              경험 해보고 결정하세요.
            </TextBlock>
          </GridItem>
          <GridItem
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-delay="100"
          >
            <TargetImage src={ImageTarget2_03} alt="icon" />
            <TextBlock fontSize="16" textAlign="center">
              관제/예약 내역 확인 가능한 ERP 서비스를<br />
              무상 제공해드립니다.
            </TextBlock>
          </GridItem>
        </ColumnGrid>
      </InnerSection>
    </Section>
  );
}
const TargetImage = styled.img`
  display: block;
  width: 378px;
  max-width: 100%;
  margin: 0 auto 29px;
  @media (max-width: 640px) {
    width: 100%;
    margin: 0 auto 16px;
  }
`;
const ColumnGrid = styled(ThreeColumnGrid)`
  margin-top: 53px;
  @media (max-width: 640px) {
    margin-top: 24px;
  }
`;
const ItemTitle = styled(TextBlock).attrs({
  fontWeight: `bold`,
  fontSize: `24`,
})`
  margin-bottom: 12px;
`;
export default TargetContainer2;
